import defaults from 'lodash/defaults';

export const formatDefaults = {
	number: '0#',
	letter: 'aA?',
	mixed: 'xX_'
};

// inspired by this method:
// https://github.com/estelle/input-masking/blob/master/js/masking-input.js

export function strictFormat(value, mask, options) {
	const opt = defaults(options, formatDefaults);
	const stripped = value.replace(/\W/g, ''); // work with raw values, exclude special chars
	let result = '';

	for (let i = 0, j = 0, l = mask.length; i < l; i++) {
		const isNumber = !isNaN(parseInt(stripped[j], 10));
		const isLetter = stripped[j] ? stripped[j].match(/[A-Z]/i) : false;
		const matchesNumber = opt.number.indexOf(mask[i]) > -1;
		const matchesLetter = opt.letter.indexOf(mask[i]) > -1;
		const matchesMixed = opt.mixed.indexOf(mask[i]) > -1;

		if ((matchesNumber && isNumber) || (matchesLetter && isLetter) || (matchesMixed && (isLetter || isNumber))) {
			// matches the format, so we'll add it
			result += isLetter
				? strictFormatChar(stripped[j], mask[i])
				: stripped[j];
			j++;
		}
		else if ((matchesNumber && !isNumber) || (matchesLetter && !isLetter) || (matchesMixed && !isLetter && !isNumber)) {
			// break it off right now,
			// because the char doesn't match what it should
			return result;
		}
		else {
			// doesn't match either letter or number,
			// so it must be a mask char, and we'll add it as is
			result += mask[i];
		}

		if (stripped[j] == null) {
			// no characters left
			break;
		}
	}

	return result;
}

export function strictFormatChar(valueChar, maskChar) {
	if (!maskChar.match(/[A-Z]/i)) {
		// the mask doesn't specify if it's upper or lower case,
		// so we'll return the char as is
		return valueChar;
	}
	const matchesUppercase = maskChar.match(/[A-Z]/);
	return matchesUppercase
		? valueChar.toUpperCase()
		: valueChar.toLowerCase();
}